import React from "react";
import { useSelector } from "react-redux";
import UPTMLanding from "../../components/upgrade-pt-membership/UPTMLanding";
import { selectUser } from "../../components/auth/auth.selector";

const UpgradePtMembership = () => {
  const userInfoData = useSelector(selectUser);

  return <UPTMLanding userInfoData={userInfoData} />;
};

export default UpgradePtMembership;
